class PoojariAttendanceStrategy {
     constructor () {
          this.employeeType = 'Poojari';
     }

     calculateAttendanceStatus(day, roster, holidays, employeeData) {
          const dateObj = new Date(day.date);
          const punchIn = day.punch_in ? new Date(day.punch_in) : null;
          const punchOut = day.punch_out ? new Date(day.punch_out) : null;

          // Check if future date
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const currentDate = new Date(day.date);
          currentDate.setHours(0, 0, 0, 0);
          const isFutureDate = currentDate > today;

          // Priority 1: Future Date
          if (isFutureDate) {
               return {
                    status: "-",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#94a3b8",
                    remarks: "Future Date"
               };
          }

          // Priority 2: Weekly Off - Fixed Sunday
          const isSunday = dateObj.getDay() === 0;
          if (isSunday || roster?.custom_weekoff_date === day.date) {
               return {
                    status: "Week Off",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#3b82f6",
                    remarks: "Sunday - Weekly Off"
               };
          }

          // Priority 3: National Holiday (Only 26 Jan, 15 Aug, 2 Oct)
          const holidayObj = holidays?.find(h => h.holiday_date === day.date);
          if (holidayObj && this.isNationalHoliday(holidayObj.holiday_date)) {
               return {
                    status: holidayObj.holiday_name,
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#8b5cf6",
                    remarks: "National Holiday"
               };
          }

          // Priority 4: No Roster Assigned
          if (!roster || !roster.shift_id) {
               return {
                    status: "LOP",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#ef4444",
                    remarks: "No shift assigned"
               };
          }

          // Priority 5: No Punch In/Out - Absent
          if (!punchIn || !punchOut) {
               return {
                    status: "Absent",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#ef4444",
                    remarks: "Missed punch"
               };
          }

          // Calculate working hours
          const workedMinutes = Math.round((punchOut - punchIn) / (1000 * 60));
          const workingHours = this.calculateWorkingHours(punchIn, punchOut);

          // Rule 1: No Late Mark for Poojaris
          const lateMark = "-";

          // Rule 3: Duty Hours Validation
          // Get shift total hours from roster (convert to minutes)
          const fullDayMinutes = roster?.WorkingsHoursToBeConsiderdFullDay
               ? parseFloat(roster.WorkingsHoursToBeConsiderdFullDay) * 60
               : 480; // Default 8 hours

          const halfDayMinutes = fullDayMinutes * 0.5; // 50% of full day

          // Priority 6: Full Day - Completed full shift hours
          if (workedMinutes >= fullDayMinutes) {
               return {
                    status: "Present",
                    lateMark,
                    workingHours,
                    statusColor: "#10b981",
                    remarks: "Completed full shift hours"
               };
          }

          // Priority 7: Half Day - Completed at least 50% of shift hours
          if (workedMinutes >= halfDayMinutes) {
               return {
                    status: "Half Day",
                    lateMark,
                    workingHours,
                    statusColor: "#f59e0b",
                    remarks: `Worked ${Math.round((workedMinutes / fullDayMinutes) * 100)}% of shift hours`
               };
          }

          // Priority 8: Less than 50% - Absent
          return {
               status: "Absent",
               lateMark,
               workingHours,
               statusColor: "#ef4444",
               remarks: "Worked less than 50% of shift hours"
          };
     }

     calculateWorkingHours(punchIn, punchOut) {
          if (!punchIn || !punchOut) return '00:00';

          const punchInDate = new Date(punchIn);
          const punchOutDate = new Date(punchOut);
          const diffMs = punchOutDate - punchInDate;

          if (diffMs <= 0) return '00:00';

          const totalMinutes = Math.floor(diffMs / (1000 * 60));
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;

          return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
     }

     isNationalHoliday(date) {
          // Only three national holidays: Republic Day, Independence Day, Gandhi Jayanti
          const nationalHolidays = ['01-26', '08-15', '10-02'];
          const dateStr = date.substring(5); // Extract MM-DD from YYYY-MM-DD
          return nationalHolidays.includes(dateStr);
     }

     // No TDS calculation needed for attendance
     calculateTDS(grossEarnings, panLinked, panOperative) {
          if (grossEarnings < 50000) {
               return {
                    tds_amount: 0,
                    tds_rate: 0,
                    pan_status: "Not Applicable",
                    pan_aadhaar_linked: false
               };
          }
          return {
               tds_amount: (grossEarnings * 1) / 100,
               tds_rate: 1,
               pan_status: panOperative ? "Operative" : "Inoperative",
               pan_aadhaar_linked: panLinked
          };
     }
}

export default PoojariAttendanceStrategy;